
export default function Features() {
  const features = [
    {
      id: 1,
      label: 'SECURITY',
      title: 'Military-Grade Encryption',
      description: 'Advanced encryption protocols protect your data from unauthorized access',
      image: 'https://public.readdy.ai/ai/img_res/845a5c1bbd32bedaef74fb87c2815996.jpg',
      labelColor: 'bg-lime-400 text-lime-900'
    },
    {
      id: 2,
      label: 'PERFORMANCE',
      title: 'Lightning Fast Speed',
      description: 'Optimized algorithms ensure smooth performance without compromising device resources',
      image: 'https://readdy.ai/api/search-image?query=Neon%20yellow%20green%20speed%20gauge%20speedometer%20on%20dark%20navy%20background%2C%20modern%20digital%20dashboard%20design%2C%20glowing%20performance%20meter%2C%20minimalist%20tech%20interface%2C%20high-speed%20indicator%2C%20contemporary%20UI%20element%2C%20professional%20visualization&width=600&height=400&seq=feature-performance-delko&orientation=landscape',
      labelColor: 'bg-lime-400 text-lime-900'
    },
    {
      id: 3,
      label: 'EXPERIENCE',
      title: 'Intuitive Interface Design',
      description: 'User-friendly interfaces make complex features accessible to everyone',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20iOS%20mobile%20app%20interface%20screenshot%20on%20light%20background%2C%20minimalist%20UI%20design%2C%20elegant%20user%20experience%2C%20contemporary%20app%20screen%2C%20professional%20mobile%20interface%2C%20sleek%20navigation%2C%20Apple%20design%20language%2C%20premium%20app%20aesthetic&width=600&height=400&seq=feature-experience-delko&orientation=landscape',
      labelColor: 'bg-lime-400 text-lime-900'
    }
  ];

  return (
    <section id="features" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
          <div>
            <h2 className="text-5xl font-bold text-gray-900 leading-tight">
              Key Features<br />
              <span className="italic text-gray-700">That Set Us Apart</span>
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-lg text-gray-600 leading-relaxed">
              Our applications combine cutting-edge security technology with intuitive design, delivering seamless experiences that protect and optimize your iOS devices.
            </p>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div 
              key={feature.id}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-shadow duration-300"
            >
              {/* Image */}
              <div className="w-full h-64 overflow-hidden">
                <img 
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className={`inline-block px-4 py-1 ${feature.labelColor} rounded-full mb-4`}>
                  <span className="text-xs font-bold uppercase tracking-wide">{feature.label}</span>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3 leading-tight">
                  {feature.title}
                </h3>
                <p className="text-base text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
